import { wrappingInputRule } from 'prosemirror-inputrules';
import { InputRulesProps } from '../types';
import { BaseNode } from './base/BaseNode';

export class UnorderedList extends BaseNode {
  constructor() {
    super('bullet_list');
  }

  get schema() {
    return {
      group: 'block list',
      content: 'list_item+',
      parseDOM: [{ tag: 'ul' }],
      toDOM() {
        return ['ul', 0] as const;
      },
    };
  }

  inputRules({ schema }: InputRulesProps) {
    return [wrappingInputRule(/^\s*([-+*])\s$/, schema.nodes.bullet_list)];
  }
}
